import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Switch } from 'react-router-dom';
import { useGoogleCredentialForAuthentication } from '../google-authentication/google-prompt/useGoogleCredentialForAuthentication';
import { useSyncStepToUrl } from '../routing/useSyncStepToUrl';
import DefaultSignupRedirect from './DefaultSignupRedirect';
import RemoveTrailingSlashRedirect from './RemoveTrailingSlashRedirect';
import { useFlowRoutes } from './useFlowRoutes';
export default function Routes() {
  useGoogleCredentialForAuthentication();
  useSyncStepToUrl();
  const flowRoutes = useFlowRoutes();
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(RemoveTrailingSlashRedirect, {
      from: "/:flow/*"
    }), flowRoutes, /*#__PURE__*/_jsx(DefaultSignupRedirect, {
      from: "*"
    })]
  });
}